var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAddPropertyPaymentVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.99,
    height: 13.057,
    viewBox: "0 0 42.99 13.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_add_property_payment_visa",
    transform: "translate(17071 -7174.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M155.933,671.994l2.183-12.283h3.412l-2.115,12.283Z",
    transform: "translate(-17211.17 6514.762)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M155.933,671.994l2.8-12.283h2.8l-2.115,12.283Z",
    transform: "translate(-17211.17 6514.762)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M174.9,659.609a8.646,8.646,0,0,0-3.139-.546c-3.413,0-5.869,1.706-5.869,4.162,0,1.842,1.706,2.8,3.071,3.412s1.774,1.024,1.774,1.569c0,.819-1.092,1.228-2.047,1.228a7.418,7.418,0,0,1-3.275-.683l-.478-.2-.478,2.8a11.068,11.068,0,0,0,3.89.683c3.612,0,6.005-1.706,6.005-4.3,0-1.433-.888-2.525-2.935-3.412-1.228-.615-1.978-.955-1.978-1.569,0-.546.614-1.092,1.978-1.092a6.26,6.26,0,0,1,2.594.477l.341.137.546-2.661Z",
    transform: "translate(-17214.305 6515)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M174.9,659.609a8.646,8.646,0,0,0-3.139-.546c-3.413,0-5.255,1.706-5.255,4.162a3.566,3.566,0,0,0,2.457,3.412c1.364.615,1.774,1.024,1.774,1.569,0,.819-1.092,1.228-2.047,1.228a7.418,7.418,0,0,1-3.275-.683l-.478-.2-.478,2.8a11.068,11.068,0,0,0,3.89.683c3.612,0,6.005-1.706,6.005-4.3,0-1.433-.888-2.525-2.935-3.412-1.228-.615-1.978-.955-1.978-1.569,0-.546.614-1.092,1.978-1.092a6.26,6.26,0,0,1,2.594.477l.341.137.546-2.661Z",
    transform: "translate(-17214.305 6515)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M186.247,659.711c-.819,0-1.433.069-1.774.888l-5.118,11.393h3.685l.682-2.047h4.367l.41,2.047h3.275l-2.867-12.281Zm-1.569,8.188c.2-.615,1.364-3.612,1.364-3.612s.273-.75.478-1.228l.2,1.159s.683,3.071.819,3.753h-2.866Z",
    transform: "translate(-17219.785 6514.762)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M187.065,659.711c-.819,0-1.433.069-1.774.888l-5.936,11.393h3.685l.682-2.047h4.367l.41,2.047h3.275l-2.867-12.281Zm-2.388,8.188c.273-.683,1.364-3.612,1.364-3.612s.273-.75.478-1.228l.2,1.159s.683,3.071.819,3.753h-2.866Z",
    transform: "translate(-17219.785 6514.762)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M143.026,668.35l-.341-1.774a9.893,9.893,0,0,0-4.777-5.391l3.071,10.918h3.685l5.528-12.283h-3.686Z",
    transform: "translate(-17204.541 6514.722)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M143.026,668.35l-.341-1.774a9.893,9.893,0,0,0-4.777-5.391l3.071,10.918h3.685l5.528-12.283h-3Z",
    transform: "translate(-17204.541 6514.722)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M131,659.711l.614.137c4.367,1.024,7.37,3.612,8.53,6.688l-1.228-5.8c-.2-.819-.819-1.024-1.569-1.024Z",
    transform: "translate(-17202 6514.762)",
    fill: "#ffbc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M131,659.711c4.367,1.024,7.984,3.685,9.144,6.755l-1.16-4.845a1.668,1.668,0,0,0-1.637-1.3Z",
    transform: "translate(-17202 6514.762)",
    fill: "#f7981d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M131,659.711c4.367,1.024,7.984,3.685,9.144,6.755l-.819-2.661a2.409,2.409,0,0,0-1.433-1.978Z",
    transform: "translate(-17202 6514.762)",
    fill: "#ed7c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M146.478,668.693l-2.315-2.316-1.092,2.593-.273-1.706a9.892,9.892,0,0,0-4.78-5.4l3.07,10.918h3.685Z",
    transform: "translate(-17204.58 6513.968)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M159.413,677.392l-2.934-3-.546,3Z",
    transform: "translate(-17211.17 6509.363)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M170.4,672.447c.273.274.409.478.341.75,0,.819-1.092,1.228-2.047,1.228a7.422,7.422,0,0,1-3.275-.683l-.478-.2-.477,2.8a11.068,11.068,0,0,0,3.89.683,6.762,6.762,0,0,0,4.982-1.706Z",
    transform: "translate(-17214.307 6510.078)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M180.111,673.938h3.207l.682-2.047h4.367l.41,2.047h3.275l-1.16-4.982L186.8,665l.2,1.092s.683,3.071.819,3.753h-2.866c.274-.683,1.364-3.612,1.364-3.612s.274-.75.478-1.228",
    transform: "translate(-17220.063 6512.817)",
    fill: "#051244"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddPropertyPaymentVisa);
export default __webpack_public_path__ + "static/media/ic_add_property_payment_visa.013b165760c4df1bbc40ba4834b0ffc4.svg";
export { ForwardRef as ReactComponent };